import {useContext} from "react"
import {AuthContext} from "@/library/auth/auth-context"

export default function useAuth() {
    return useContext(AuthContext)
}
